import { DeleteOutlined, EditOutlined, KeyOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Form, Input, Layout, message, Modal, Pagination, Popconfirm, Row, Select, Space, Spin, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import axiosInstance from "../../../../api/axiosInstance";
import { User } from "../../../../services/users/user";
import { useNavigate } from "react-router-dom";
import { Coach } from "../../../../services/coaches/coach";
const { TextArea } = Input;
const { Content } = Layout;
const { Option } = Select;

const CoachManagement = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [tableHeight, setTableHeight] = useState(500);
    const [data, setData] = useState<Coach[]>([]);
    const [searchText, setSearchText] = useState("");
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [formCoach] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [listUser, setListUsers] = useState<User[]>([]);

    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 10,
        keyword: '',
        summary: '',
        filters: [],
        orders: [
            new OrderValue({ propertyName: 'createdDate', type: OrderTypes.Desc, index: 0 }),
            new OrderValue({ propertyName: 'status', type: OrderTypes.Asc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));
    const [userfilter, setUserFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 1000,
        keyword: '',
        summary: '',
        filters: [],
        orders: [new OrderValue({ propertyName: 'userCode', type: OrderTypes.Desc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));

    useEffect(() => {
        const width = window.innerWidth;
        if (width <= 1366) setTableHeight(250);
        else setTableHeight(500);
    }, []);

    useEffect(() => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchCoachs(params);
    }, []);

    const fetchCoachs = async (paramValues?: any) => {
        try {
            setLoading(true);
            const response = await axiosInstance.get("/coaches", {
                params: paramValues ?? filter,
            });
            const items = response.data?.list || [];
            setTotalRecords(response.data?.totalRecords || 0);
            const formattedData: Coach[] = items.map((item: any) => new Coach(item));

            setData(formattedData);
        } catch (error: any) {
            console.error("Lỗi khi lấy danh sách giải đấu:", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };
    const getListUser = async (paramValues?: any) => {
        try {
            const params = FilterHelper.getParamWithFilter(userfilter);

            const response = await axiosInstance.get("/user", {
                params: params,
            });
            const listUsers = response.data?.list.map((x: any) => new User(x)) || [];
            setListUsers(listUsers)
        } catch (error) {
            message.error("Không thể tải danh sách người dùng!");
        }
    };
    const handlePaginationChange = (page: number, pageSize: number) => {
        const newFilter = new FilterRequest({
            ...filter,
            page,
            limit: pageSize,
        });
        setFilter(newFilter);
        const params = FilterHelper.getParamWithFilter(newFilter);
        fetchCoachs(params);
    };
    const handleCreateCoach = () => {
        getListUser();
        setIsModalVisible(true);
    }

    const handleReloadCoach = () => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchCoachs(params);
    }
    const handleEditCoach = (record: Coach) => {
        navigate(`coach-detail-management/${record.coachID}`);
    };

    const handleDeleteCoach = async (record: Coach) => {
        try {
            await axiosInstance.put(`/coaches/delete-coach`, { CoachIDs: [record.coachID] });
            message.success("Xoá huấn luyện viên thành công!");
            const params = FilterHelper.getParamWithFilter(filter);
            fetchCoachs(params);
        }
        catch (error: any) {
            message.error(error?.response?.data?.systemMessage || "Có lỗi xảy ra khi xóa.");
        }
    }

    const columns: ColumnsType<any> = [
        { title: "ID", dataIndex: "userCode", key: "userCode", width: 200 },
        { title: "NickName", dataIndex: "nickName", key: "nickName" },
        { title: "FullName", dataIndex: "fullName", key: "fullName" },
        { title: "Giới thiệu", dataIndex: "introduction", key: "introduction" },
        { title: "Mô tả", dataIndex: "description", key: "description" },
        {
            title: "Hành động",
            key: "action",
            width: 150,
            render: (_: any, record: Coach) => (
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => handleEditCoach(record)} />
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteCoach(record)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];


    const handleOk = async () => {
        try {
            const values = await formCoach.validateFields();
            await axiosInstance.post(`/coaches/create-coach`, values);
            message.success("Tạo bản ghi thành công!");
            const params = FilterHelper.getParamWithFilter(filter);
            fetchCoachs(params);
            setIsModalVisible(false);
            formCoach.resetFields();
        } catch (error: any) {
            message.error(error?.response?.data?.systemMessage || "Có lỗi xảy ra khi tạo.");
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        formCoach.resetFields();
    };

    return (
        <Content style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 999,
                    padding: "16px",
                    borderBottom: "1px solid #ddd",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
            >
                <Space style={{ width: "100%" }}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ backgroundColor: "#F48100", borderColor: "#F48100" }}
                        onClick={handleCreateCoach}
                    >
                        Thêm mới
                    </Button>
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={handleReloadCoach}
                    >
                        Làm mới
                    </Button>
                </Space>
            </div>
            <div style={{ flex: 1, overflow: "auto", marginTop: "16px" }}>
                {loading ? (
                    <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                ) : (
                    <Table
                        columns={columns}
                        onRow={(record) => ({
                            onClick: (e) => {
                                const actionColumnIndex = columns.findIndex((col) => col.key === 'action');
                                const clickedColumn = (e.target as HTMLElement).closest('td');

                                if (clickedColumn && clickedColumn.cellIndex === actionColumnIndex) {
                                    return;
                                }
                            },
                        })}
                        dataSource={data}
                        pagination={false}
                        scroll={{ y: tableHeight }}
                    />
                )}
            </div>
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#fff",
                    paddingTop: "10px",
                    borderTop: "-1px solid #ddd",
                    boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
            >
                <Pagination
                    current={filter.page}
                    pageSize={filter.limit}
                    total={totalRecords}
                    onChange={handlePaginationChange}
                    showTotal={(total, range) =>
                        `Hiển thị ${range[0]} - ${range[1]} của ${total} bản ghi`
                    }
                />
            </div>
            <Modal
                title="Thông tin huấn luyện viên"
                visible={isModalVisible}
                onCancel={handleCancel}
                onOk={handleOk}
                okButtonProps={{ style: { backgroundColor: "#F48100", borderColor: "#F48100" } }}
                cancelButtonProps={{ style: { backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" } }}
                okText="Xác nhận"
                cancelText="Huỷ"
                width={800}
                bodyStyle={{ padding: 0, maxHeight: '70vh', overflowY: 'auto' }}
            >
                <Form layout="vertical" form={formCoach}>
                    <Card>
                        <div className="p-6 bg-white rounded-lg shadow-md">
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Form.Item
                                                label={<strong>Chọn huấn luyện viên</strong>}
                                                name="userID"
                                                rules={[{ required: true, message: 'Vui lòng chọn huấn luyện viên' }]}
                                            >
                                                <Select
                                                    placeholder="Vui lòng chọn huấn luyện viên"
                                                    showSearch
                                                    filterOption={(input, option) => {
                                                        const label = `${option?.children}`.toLowerCase();
                                                        return label.includes(input.toLowerCase());
                                                    }}
                                                >
                                                    {listUser.map((user) => (
                                                        <Option key={user.id} value={user.id}>
                                                            {user.userCode} - {user.nickName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item label={<strong>Facebook</strong>} name="facebook">
                                                <Input placeholder="https://www.facebook.com" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label={<strong>Số Zalo</strong>} name="zalo">
                                                <Input placeholder="Nhập số Zalo" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item label={<strong>Khu vực dạy</strong>} name="instructionArea">
                                                <TextArea rows={2} placeholder="Nhập khu vực dạy" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item label={<strong>Giới thiệu về huấn luyện viên</strong>} name="introduction">
                                                <TextArea rows={4} placeholder="Nhập giới thiệu về huấn luyện viên" />
                                            </Form.Item>
                                        </Col>
                                        {/* <Col span={24}>
                                            <Form.Item label={<strong>Thành tích của huấn luyện viên</strong>} name="achievement">
                                                <TextArea rows={4} placeholder="Nhập thành tích của huấn luyện viên" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item label={<strong>Ghi chú</strong>} name="description">
                                                <TextArea rows={4} placeholder="Nhập ghi chú" />
                                            </Form.Item>
                                        </Col> */}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Form>
            </Modal>
        </Content>
    )
}
export default CoachManagement